const state = {
  isDrawerOpen: false
};

const mutations = {
  setDrawerOpen(state, isOpen) {
    state.isDrawerOpen = isOpen;
  }
};

const getters = {
  isDrawerOpen: state => state.isDrawerOpen
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};
